export interface QuantityEntitlementDTO {
    quantity: number | null
    unlimited: boolean
}

export class BillingDetailsDTO {

    constructor(
        public inService: boolean,
        public needsToUpgradeTrial: boolean,
        public nextBillingPeriod: 'MONTHLY' | 'ANNUALLY',
        public nextBillingAmount: string,
        public nextBillingAmountCurrencyCode: string,
        public nextBillingDate: Date | null,
        public addons: string[],
        public entitlements: string[] = [],
        public quantityEntitlements: Record<string, QuantityEntitlementDTO> = {}
    ) { }
}
